<template>
  <!-- Same shape as the js-lib EventMeta chips, in the info colours -->
  <span
    class="flex gap-2 items-center shrink-0 whitespace-nowrap text-xs px-3 py-1 rounded-full bg-info-muted text-info-muted-foreground">
    <SprintIcon class="size-4" aria-hidden="true" />
    <span>{{ $t("Sprint") }}</span>
  </span>
</template>

<script setup lang="ts">
import SprintIcon from "~icons/material-symbols/electric-bolt";
</script>
